import React from 'react'

import { Carousel } from 'primereact/carousel'

import "../index.css"
import { numberConversion } from '../../../../utils'

const responsiveOptions = [
    { breakpoint: '1400px', numVisible: 2, numScroll: 1 },
    { breakpoint: '1199px', numVisible: 2, numScroll: 1 },
    { breakpoint: '767px', numVisible: 2, numScroll: 1 },
    { breakpoint: '575px', numVisible: 1, numScroll: 1 }
]


const FrequentlyBoughtItemsWith = (props) => {
	const { eachProduct, products, handleViewProduct } = props

	const frequentlyBoughtWithItems = products.filter(eachItem => eachProduct.freqBoughtWith?.includes(eachItem.materialId))

	const productTemplate = (product) => {
		const materialImage = product.materialImage?.length > 0 ? product.materialImage[0] : "https://procmart-tech.s3.ap-south-1.amazonaws.com/app-images/no_image_no_pg+(6).png"

		return (
			<div 
                className="carousel-container border-1 surface-border border-round  p-1 text-center"
				onClick={() => handleViewProduct(product.buyerRateContractId)}
				style={{ cursor: 'pointer', height: "130px" }}  
            >
				<div className="carousel-image-container w-3 ml-1">
					<img
						src={materialImage}
						alt={product.companyProdName}
						className="carousel-product-img "
						style={{ width: '80px', height: '80px', objectFit: 'cover' }}
					/>
				</div>
				<div className="carousel-details w-9 ml-2">
					<h4 className="product-name">{product.companyProdName}</h4>
					<p className="product-spec my-1">{product.companyProdSpec}</p>
					<h6 className='text-left product-type'>{product.companyERPCategory}</h6>
					<h6 className="product-price mt-1 mb-2 text-left">₹ {numberConversion(product.unitPrice, "en-IN")}</h6>
				</div>
			</div>
		)
	}

	if(!frequentlyBoughtWithItems.length){
		return
	}

	return (
		<>
			<div className='pl-6'>
				<h2 className='dialog-carousel-header mb-3'>Bought Together</h2>
			</div>
			<div className="card dialog-carousel">
				<Carousel
					value={frequentlyBoughtWithItems}
					numVisible={2}
					numScroll={1}
					responsiveOptions={responsiveOptions}
					itemTemplate={productTemplate}
					circular
				/>
			</div>
		</>
	)
}

export default FrequentlyBoughtItemsWith